import { IUserStatus } from "./user.interface";

export const UserStatus: IUserStatus = {
  pending: "Pending",
  approved: "Active",
  reject: "Reject",
};
